module.exports = __webpack_public_path__ + "img/propertyInfoBg.a6b814cd.png";